"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var actions_1 = require("@/pages/common/components/contact/actions");
var classNames = require("classnames");
var mapStateToProps = function (state, ownProps) { return (__assign(__assign({}, state.contact), { mobileHidden: ownProps.mobileHidden })); };
var mapDispatchToProps = function (dispatch) { return ({
    onContactFormClicked: function () { return dispatch(actions_1.default.onContactFormClicked()); },
}); };
var contactrem = function (props) {
    var contactClass = classNames(['c-contactrem', { 'u-mobile-hidden': props.mobileHidden }]);
    var divAttrs = props.isDomLoaded ? { backgroundImage: 'url(https://images.okay.com/website/common/images/agents.webp)' } : { backgroundImage: 'none' };
    return (React.createElement("div", { className: contactClass },
        React.createElement("div", { className: "c-contactrem__bg", style: divAttrs }),
        React.createElement("div", { className: "c-contactrem__container" },
            React.createElement("h2", { className: "c-contactrem__head", dangerouslySetInnerHTML: { __html: props.heading } }),
            React.createElement("div", { className: "c-contactrem__action" },
                React.createElement("a", { style: { cursor: 'pointer' }, onClick: props.onContactFormClicked, className: "c-contactrem__btn" }, props.nameContactUs)))));
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(contactrem);
